import * as React from "react";
import { forwardRef } from "react";
const SvgInteractionDirectionAlt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#98A9BC", fillRule: "evenodd", d: "M4.471 16v-5.333h1.334v2.98l8.846-9.436.974.911-8.948 9.545h3.128V16zM.943 11.138 0 10.195l8.862-8.862H5.805V0h5.333v5.333H9.805V2.276z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgInteractionDirectionAlt);
export { ForwardRef as ReactComponent };
